// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"OrgsDropDownHeader_dropdown_1uTSF","avatar":"OrgsDropDownHeader_avatar_2h4eb"};